<template>
    <div
        class="truck-marker"
        :style="{
            width: size + 'px',
            height: size + 'px',
            minWidth: size + 'px',
            border,
            borderColor,
            boxShadow,
        }"
    >
        <img v-if="src" :src="src" class="truck-marker__img" alt="Avatar" />
    </div>
</template>

<script>
export default {
    name: 'BaseAvatar',
    props: {
        src: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: 64,
        },
    },
    computed: {
        border() {
            const borderSize = Math.round(this.size * 0.045)
            return `${borderSize}px solid ${this.borderColor}`
        },
        borderColor() {
            return this.color
        },
        boxShadow() {
            const offset = Math.round(this.size * 0.08)
            return `0px ${offset}px 5px 0px rgba(0, 0, 0, 0.4)`
        },
    },
}
</script>

<style lang="scss" scoped>
.truck-marker {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border-style: solid;
    background-color: #fff;

    &__img {
        width: 70%;
        height: auto;
    }
}
</style>
